import orderInstance from '../instance'

const setOrderStatus = (orderId, data) => {
  return orderInstance.put('/orders/' + orderId + '/status', data)
}

export default setOrderStatus
